import { render, staticRenderFns } from "./SubjectsStatistics.vue?vue&type=template&id=d678169c&scoped=true"
import script from "./SubjectsStatistics.vue?vue&type=script&lang=js"
export * from "./SubjectsStatistics.vue?vue&type=script&lang=js"
import style0 from "./SubjectsStatistics.vue?vue&type=style&index=0&id=d678169c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d678169c",
  null
  
)

export default component.exports